import TranslateApi from "src/utils/TranslateHelper";

export class TextItem extends Phaser.GameObjects.Text {
    textId: number;
    startingPosition: Phaser.Geom.Rectangle;
    startingAngle: number;
    startingSize: Phaser.Math.Vector2;
    translationKey: string;

    constructor(scene, x: number, y: number, textId: number) {
        var style = {
            color: "#000000",
            align: "centered",
            fontFamily: 'Russo One, Roboto Mono,  Arial',
            fontSize: 70, // Initially big font size for better quality when resizing
        };

        var text = TranslateApi.translate("Collage.Phaser.CollageAssets." + textId);
        super(scene, x, y, text, style);

        this.textId = textId;
        this.startingAngle = 0;
        this.startingPosition = null;
        this.setOrigin(0.5);
        this.setWordWrapWidth(900, true);
        this.shrink();
        this.type = "TextItem";
        this.translationKey = "Collage.Phaser.CollageAssets." + textId;
        this.scene.add.existing(this);

        // One time event that will play it's audio 
        this.once("dragstart", () => {
            this.scene.sound.stopAll();
            this.scene.sound.play(this.translationKey);
        });
    }

    shrink() {
        this.displayHeight *= 0.3;
        this.displayWidth *= 0.3;
        this.startingSize = new Phaser.Math.Vector2(this.displayWidth, this.displayHeight);
        this.setInteractive();
        this.scene.input.setDraggable(this);
    }
}

export class ImageItem extends Phaser.GameObjects.Image {
    startingPosition: Phaser.Geom.Rectangle;
    startingAngle: number;
    startingSize: Phaser.Math.Vector2;

    constructor(scene, x: number, y: number, texture: string) {
        super(scene, x, y, texture);

        this.startingAngle = 0;
        this.startingPosition = null;
        this.type = "ImageItem";
        this.scene.add.existing(this);
    }
}





// WEBPACK FOOTER //
// ./src/games/CollageGame/objects/Item.ts